<template>
    <div class="secondTest">
        <img class="small-tree animationLeftRight pos" src="http://wwj.jijiagames.com/web/act/20190702/small_tree.png" alt="">
        <img class="second-smallTree animationLeftRight pos" src="../assets/img/second_smallTree.png" alt="">
        <img class="second-box pos" src="../assets/img/second_box.png" alt="">
        <img class="second-xianrenz animationLeftRight pos" src="../assets/img/second_xianrenz.png" alt="">
        <img class="second-redhua animationLeftRight pos" src="http://wwj.jijiagames.com/web/act/20190702/second_redhua.png" alt="">
        <img class="second-liaTree pos" src="http://wwj.jijiagames.com/web/act/20190702/second_liaTree.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>

.secondTest
    .small-tree
        top 0
        right 0.3rem 
    .second-smallTree
        width 60%
        bottom -0.5rem
        left 1.5rem
    .second-box
        width 36%
        bottom 0
        left 1.78rem
    .second-xianrenz
        bottom 0
        right -2.1rem
    .second-redhua
        width 50%
        bottom -0.2rem
        right -2.4rem
    .second-liaTree
        top 0
        right -2.7rem

</style>
